import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Medal, Star, Zap, Heart, Flame } from 'lucide-react';
const recognitions = [{
  icon: Star,
  label: 'Constância do mês',
  color: 'text-yellow-500',
  bg: 'bg-yellow-50'
}, {
  icon: Zap,
  label: 'Maior evolução',
  color: 'text-blue-500',
  bg: 'bg-blue-50'
}, {
  icon: Flame,
  label: 'Superação',
  color: 'text-orange-500',
  bg: 'bg-orange-50'
}, {
  icon: Heart,
  label: 'Desempenho cardio',
  color: 'text-red-500',
  bg: 'bg-red-50'
}, {
  icon: Medal,
  label: 'Disciplina (streaks)',
  color: 'text-purple-500',
  bg: 'bg-purple-50'
}];
export function GamificationSection() {
  return <Section data-id="element-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="order-2 lg:order-1" data-id="element-22">
          <div className="relative bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-23">
            {/* Podium Visual */}
            <div className="flex items-end justify-center gap-4 h-64 mb-8" data-id="element-24">
              <div className="w-24 bg-gray-200 rounded-t-lg h-32 flex flex-col items-center justify-end p-4 shadow-inner" data-id="element-25">
                <span className="text-4xl font-bold text-gray-400 opacity-50" data-id="element-26">
                  2
                </span>
                <div className="w-10 h-10 rounded-full bg-gray-300 mb-2" data-id="element-27"></div>
              </div>
              <div className="w-24 bg-[#FF6B35] rounded-t-lg h-48 flex flex-col items-center justify-end p-4 shadow-lg relative z-10" data-id="element-28">
                <div className="absolute -top-6" data-id="element-29">
                  <Medal className="h-12 w-12 text-yellow-400 drop-shadow-md" data-id="element-30" />
                </div>
                <span className="text-5xl font-bold text-white opacity-50" data-id="element-31">
                  1
                </span>
                <div className="w-12 h-12 rounded-full bg-white/20 mb-2" data-id="element-32"></div>
              </div>
              <div className="w-24 bg-gray-200 rounded-t-lg h-24 flex flex-col items-center justify-end p-4 shadow-inner" data-id="element-33">
                <span className="text-4xl font-bold text-gray-400 opacity-50" data-id="element-34">
                  3
                </span>
                <div className="w-10 h-10 rounded-full bg-gray-300 mb-2" data-id="element-35"></div>
              </div>
            </div>

            <div className="text-center" data-id="element-36">
              <p className="text-sm text-gray-500 font-medium" data-id="element-37">
                Rankings por categoria e nível
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="order-1 lg:order-2" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-6" data-id="element-39">
            Gamificação inteligente <br data-id="element-40" />
            <span className="text-gray-400 text-2xl font-normal" data-id="element-41">
              (sem constrangimento)
            </span>
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-42">
            A participação é totalmente opcional. Nossos rankings são
            segmentados por categoria e nível, focando sempre no progresso
            pessoal e não na comparação tóxica.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-43">
            {recognitions.map((item, index) => <div key={index} className="flex items-center gap-3 p-3 rounded-lg border border-gray-100 hover:border-orange-100 hover:shadow-sm transition-all bg-white" data-id="element-44">
                <div className={`p-2 rounded-md ${item.bg}`} data-id="element-45">
                  <item.icon className={`h-5 w-5 ${item.color}`} data-id="element-46" />
                </div>
                <span className="font-medium text-gray-700" data-id="element-47">{item.label}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </Section>;
}